import { render, staticRenderFns } from "./CoProducerComission.vue?vue&type=template&id=71bf6dfd&scoped=true&"
import script from "./CoProducerComission.vue?vue&type=script&lang=js&"
export * from "./CoProducerComission.vue?vue&type=script&lang=js&"
import style0 from "./CoProducerComission.vue?vue&type=style&index=0&id=71bf6dfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf6dfd",
  null
  
)

export default component.exports